module.exports = __webpack_public_path__ + "img/template18_mobile.ca5914fb.png";